<span class="timeline__thirteen-minutes-container">
  <span 
    [class]="'timeline__thirteen-minutes' + ' ' + status() + ' ' + 'ci-paragraph-p1-semibold'"
  ></span>
</span>
